// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3Lm73","col":"styles_col__p3mgZ","fulfillmentStatus":"styles_fulfillmentStatus__tpp7Y","emailCol":"styles_emailCol__1a7UV"};